module.exports = __webpack_public_path__ + "../resources/images/SkyCode_74-11246da6470da7cc2a438c739cc37617.svg";